export default __webpack_public_path__ + "static/media/Multitool3.9650f5a8.png";